export default "__VITE_ASSET__DtvSBMmL__"